"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var class_transformer_1 = require("class-transformer");

var Goal;

(function (Goal) {
  Goal["PROTECT"] = "Prot\xE9ger sa famille";
  Goal["REDUCES_TAX"] = "R\xE9duire ses imp\xF4ts";
  Goal["COMPLEMENTARY_INCOME"] = "Revenu compl\xE9mentaire";
  Goal["RETIREMENT"] = "Pr\xE9parer sa retraite";
  Goal["HERITAGE"] = "Se constituer un patrimoine";
  Goal["CAPITAL"] = "Se constituer un capital";
})(Goal = exports.Goal || (exports.Goal = {}));

var Support;

(function (Support) {
  Support["PHONE"] = "t\xE9l\xE9phonique";
  Support["VISIO"] = "en visio-conf\xE9rence";
  Support["AGENCY"] = "\xE0 son domicile";
  Support["HOME"] = "\xE0 notre agence";
})(Support = exports.Support || (exports.Support = {}));

var FormDataDTO = function FormDataDTO() {
  _classCallCheck(this, FormDataDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataDTO.prototype, "firstname", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataDTO.prototype, "lastname", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataDTO.prototype, "email", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataDTO.prototype, "phone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataDTO.prototype, "mentions", void 0);

exports.FormDataDTO = FormDataDTO;

var FormDataProjectDTO =
/*#__PURE__*/
function (_FormDataDTO) {
  _inherits(FormDataProjectDTO, _FormDataDTO);

  function FormDataProjectDTO() {
    _classCallCheck(this, FormDataProjectDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormDataProjectDTO).apply(this, arguments));
  }

  return FormDataProjectDTO;
}(FormDataDTO);

__decorate([class_validator_1.IsEnum(Goal), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "goal", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "taxes", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "age", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "maxPrice", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "rooms", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "comment", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataProjectDTO.prototype, "live", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "address", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataProjectDTO.prototype, "contactTime", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataProjectDTO.prototype, "now", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataProjectDTO.prototype, "morning", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataProjectDTO.prototype, "afternoon", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataProjectDTO.prototype, "dayEnd", void 0);

exports.FormDataProjectDTO = FormDataProjectDTO;

var FormDataMeetingDTO =
/*#__PURE__*/
function (_FormDataDTO2) {
  _inherits(FormDataMeetingDTO, _FormDataDTO2);

  function FormDataMeetingDTO() {
    _classCallCheck(this, FormDataMeetingDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormDataMeetingDTO).apply(this, arguments));
  }

  return FormDataMeetingDTO;
}(FormDataDTO);

__decorate([class_validator_1.IsDateString(), __metadata("design:type", String)], FormDataMeetingDTO.prototype, "meetingDate", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataMeetingDTO.prototype, "support", void 0);

exports.FormDataMeetingDTO = FormDataMeetingDTO;

var SimulatorDataDTO = function SimulatorDataDTO() {
  _classCallCheck(this, SimulatorDataDTO);
};

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorDataDTO.prototype, "now", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorDataDTO.prototype, "morning", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorDataDTO.prototype, "afternoon", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorDataDTO.prototype, "dayEnd", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDataDTO.prototype, "subject", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDataDTO.prototype, "comment", void 0);

exports.SimulatorDataDTO = SimulatorDataDTO;

var FormDataContactDTO =
/*#__PURE__*/
function (_FormDataDTO3) {
  _inherits(FormDataContactDTO, _FormDataDTO3);

  function FormDataContactDTO() {
    _classCallCheck(this, FormDataContactDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormDataContactDTO).apply(this, arguments));
  }

  return FormDataContactDTO;
}(FormDataDTO);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataContactDTO.prototype, "now", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataContactDTO.prototype, "morning", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataContactDTO.prototype, "afternoon", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], FormDataContactDTO.prototype, "dayEnd", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataContactDTO.prototype, "subject", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], FormDataContactDTO.prototype, "message", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], FormDataContactDTO.prototype, "programId", void 0);

__decorate([class_transformer_1.Type(function () {
  return SimulatorDataDTO;
}), class_validator_1.IsOptional(), __metadata("design:type", SimulatorDataDTO)], FormDataContactDTO.prototype, "simData", void 0);

exports.FormDataContactDTO = FormDataContactDTO;

var SimulatorMonthlyFromHomeDTO =
/*#__PURE__*/
function (_SimulatorDataDTO) {
  _inherits(SimulatorMonthlyFromHomeDTO, _SimulatorDataDTO);

  function SimulatorMonthlyFromHomeDTO() {
    _classCallCheck(this, SimulatorMonthlyFromHomeDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorMonthlyFromHomeDTO).apply(this, arguments));
  }

  return SimulatorMonthlyFromHomeDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorMonthlyFromHomeDTO.prototype, "years", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorMonthlyFromHomeDTO.prototype, "borrowedCapital", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorMonthlyFromHomeDTO.prototype, "interestRate", void 0);

exports.SimulatorMonthlyFromHomeDTO = SimulatorMonthlyFromHomeDTO;

var SimulatorLoanDTO =
/*#__PURE__*/
function (_SimulatorDataDTO2) {
  _inherits(SimulatorLoanDTO, _SimulatorDataDTO2);

  function SimulatorLoanDTO() {
    _classCallCheck(this, SimulatorLoanDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorLoanDTO).apply(this, arguments));
  }

  return SimulatorLoanDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", String)], SimulatorLoanDTO.prototype, "loanAmount", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorLoanDTO.prototype, "personalContribution", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorLoanDTO.prototype, "loanDuration", void 0);

exports.SimulatorLoanDTO = SimulatorLoanDTO;

var SimulatorLoanFromHomeDTO =
/*#__PURE__*/
function (_SimulatorDataDTO3) {
  _inherits(SimulatorLoanFromHomeDTO, _SimulatorDataDTO3);

  function SimulatorLoanFromHomeDTO() {
    _classCallCheck(this, SimulatorLoanFromHomeDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorLoanFromHomeDTO).apply(this, arguments));
  }

  return SimulatorLoanFromHomeDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", String)], SimulatorLoanFromHomeDTO.prototype, "amount", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorLoanFromHomeDTO.prototype, "interest", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorLoanFromHomeDTO.prototype, "duration", void 0);

exports.SimulatorLoanFromHomeDTO = SimulatorLoanFromHomeDTO;

var SimulatorLoanFromProgramDTO =
/*#__PURE__*/
function (_SimulatorDataDTO4) {
  _inherits(SimulatorLoanFromProgramDTO, _SimulatorDataDTO4);

  function SimulatorLoanFromProgramDTO() {
    _classCallCheck(this, SimulatorLoanFromProgramDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorLoanFromProgramDTO).apply(this, arguments));
  }

  return SimulatorLoanFromProgramDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], SimulatorLoanFromProgramDTO.prototype, "lotId", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorLoanFromProgramDTO.prototype, "years", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorLoanFromProgramDTO.prototype, "borrowedCapital", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorLoanFromProgramDTO.prototype, "interestRate", void 0);

exports.SimulatorLoanFromProgramDTO = SimulatorLoanFromProgramDTO;

var SimulatorDebtDTO =
/*#__PURE__*/
function (_SimulatorDataDTO5) {
  _inherits(SimulatorDebtDTO, _SimulatorDataDTO5);

  function SimulatorDebtDTO() {
    _classCallCheck(this, SimulatorDebtDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorDebtDTO).apply(this, arguments));
  }

  return SimulatorDebtDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "netMonthylSalaryMainLoaner", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "netMonthlySalarySecondLoaner", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "monthlyPensionReceived", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "currentGrossMonthylRentReceived", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "ownerOfMainResidence", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "monthlyLoanPaymentOnMainProperty", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "personalContribution", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "monthlyRentOnRentedRealEstate", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "monthlyOtherLoansPayments", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "monthlyPensionsPaid", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", String)], SimulatorDebtDTO.prototype, "principalResidence", void 0);

exports.SimulatorDebtDTO = SimulatorDebtDTO;

var SimulatorDebtFromProgramDTO =
/*#__PURE__*/
function (_SimulatorDataDTO6) {
  _inherits(SimulatorDebtFromProgramDTO, _SimulatorDataDTO6);

  function SimulatorDebtFromProgramDTO() {
    _classCallCheck(this, SimulatorDebtFromProgramDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorDebtFromProgramDTO).apply(this, arguments));
  }

  return SimulatorDebtFromProgramDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], SimulatorDebtFromProgramDTO.prototype, "lotId", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorDebtFromProgramDTO.prototype, "income", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorDebtFromProgramDTO.prototype, "monthlyCredit", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorDebtFromProgramDTO.prototype, "actualRent", void 0);

exports.SimulatorDebtFromProgramDTO = SimulatorDebtFromProgramDTO;

var SimulatorPinelDTO =
/*#__PURE__*/
function (_SimulatorDataDTO7) {
  _inherits(SimulatorPinelDTO, _SimulatorDataDTO7);

  function SimulatorPinelDTO() {
    _classCallCheck(this, SimulatorPinelDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorPinelDTO).apply(this, arguments));
  }

  return SimulatorPinelDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelDTO.prototype, "pinel6Years", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelDTO.prototype, "pinel9Years", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelDTO.prototype, "pinel12Years", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelDTO.prototype, "financingDurationYears", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelDTO.prototype, "personnalContribution", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelDTO.prototype, "purchaseAmount", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelDTO.prototype, "rent", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelDTO.prototype, "surface", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelDTO.prototype, "simUntilLoanEndSelected", void 0);

exports.SimulatorPinelDTO = SimulatorPinelDTO;

var SimulatorPinelFromProgramDTO =
/*#__PURE__*/
function (_SimulatorDataDTO8) {
  _inherits(SimulatorPinelFromProgramDTO, _SimulatorDataDTO8);

  function SimulatorPinelFromProgramDTO() {
    _classCallCheck(this, SimulatorPinelFromProgramDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorPinelFromProgramDTO).apply(this, arguments));
  }

  return SimulatorPinelFromProgramDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelFromProgramDTO.prototype, "pinel6Years", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelFromProgramDTO.prototype, "pinel9Years", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], SimulatorPinelFromProgramDTO.prototype, "pinel12Years", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorPinelFromProgramDTO.prototype, "purchaseAmount", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelFromProgramDTO.prototype, "personnalContribution", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPinelFromProgramDTO.prototype, "financingDurationYears", void 0);

exports.SimulatorPinelFromProgramDTO = SimulatorPinelFromProgramDTO;

var SimulatorPTZDTO =
/*#__PURE__*/
function (_SimulatorDataDTO9) {
  _inherits(SimulatorPTZDTO, _SimulatorDataDTO9);

  function SimulatorPTZDTO() {
    _classCallCheck(this, SimulatorPTZDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorPTZDTO).apply(this, arguments));
  }

  return SimulatorPTZDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorPTZDTO.prototype, "zone", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZDTO.prototype, "occupants", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZDTO.prototype, "referenceTaxRevenue", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZDTO.prototype, "operationCost", void 0);

exports.SimulatorPTZDTO = SimulatorPTZDTO;

var SimulatorPTZFromProgramDTO =
/*#__PURE__*/
function (_SimulatorDataDTO10) {
  _inherits(SimulatorPTZFromProgramDTO, _SimulatorDataDTO10);

  function SimulatorPTZFromProgramDTO() {
    _classCallCheck(this, SimulatorPTZFromProgramDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatorPTZFromProgramDTO).apply(this, arguments));
  }

  return SimulatorPTZFromProgramDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], SimulatorPTZFromProgramDTO.prototype, "lotId", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimulatorPTZFromProgramDTO.prototype, "goodValue", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZFromProgramDTO.prototype, "people", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZFromProgramDTO.prototype, "referenceIncome", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SimulatorPTZFromProgramDTO.prototype, "personnalContribution", void 0);

exports.SimulatorPTZFromProgramDTO = SimulatorPTZFromProgramDTO;

var DebtCapaSimulatorInputDTO =
/*#__PURE__*/
function (_SimulatorDataDTO11) {
  _inherits(DebtCapaSimulatorInputDTO, _SimulatorDataDTO11);

  function DebtCapaSimulatorInputDTO() {
    _classCallCheck(this, DebtCapaSimulatorInputDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(DebtCapaSimulatorInputDTO).apply(this, arguments));
  }

  return DebtCapaSimulatorInputDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorInputDTO.prototype, "operationCost", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorInputDTO.prototype, "netMonthylSalaryMainLoaner", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorInputDTO.prototype, "monthlyLoanPaymentOnMainProperty", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorInputDTO.prototype, "personalContribution", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorInputDTO.prototype, "monthlyOtherLoansPayments", void 0);

exports.DebtCapaSimulatorInputDTO = DebtCapaSimulatorInputDTO;

var DebtCapaSimulatorOutputDTO =
/*#__PURE__*/
function (_SimulatorDataDTO12) {
  _inherits(DebtCapaSimulatorOutputDTO, _SimulatorDataDTO12);

  function DebtCapaSimulatorOutputDTO() {
    _classCallCheck(this, DebtCapaSimulatorOutputDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(DebtCapaSimulatorOutputDTO).apply(this, arguments));
  }

  return DebtCapaSimulatorOutputDTO;
}(SimulatorDataDTO);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorOutputDTO.prototype, "monthly", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorOutputDTO.prototype, "loan10Years", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorOutputDTO.prototype, "loan15Years", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorOutputDTO.prototype, "loan20Years", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorOutputDTO.prototype, "loan25Years", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorOutputDTO.prototype, "personnalContribution", void 0);

exports.DebtCapaSimulatorOutputDTO = DebtCapaSimulatorOutputDTO;

var DebtCapaSimulatorDTO =
/*#__PURE__*/
function (_SimulatorDataDTO13) {
  _inherits(DebtCapaSimulatorDTO, _SimulatorDataDTO13);

  function DebtCapaSimulatorDTO() {
    _classCallCheck(this, DebtCapaSimulatorDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(DebtCapaSimulatorDTO).apply(this, arguments));
  }

  return DebtCapaSimulatorDTO;
}(SimulatorDataDTO);

__decorate([class_transformer_1.Type(function () {
  return SimulatorDataDTO;
}), class_validator_1.IsOptional(), __metadata("design:type", DebtCapaSimulatorInputDTO)], DebtCapaSimulatorDTO.prototype, "input", void 0);

__decorate([class_transformer_1.Type(function () {
  return SimulatorDataDTO;
}), class_validator_1.IsOptional(), __metadata("design:type", DebtCapaSimulatorOutputDTO)], DebtCapaSimulatorDTO.prototype, "output", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorDTO.prototype, "operationCost", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorDTO.prototype, "netMonthylSalaryMainLoaner", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorDTO.prototype, "monthlyLoanPaymentOnMainProperty", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorDTO.prototype, "personalContribution", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], DebtCapaSimulatorDTO.prototype, "monthlyOtherLoansPayments", void 0);

exports.DebtCapaSimulatorDTO = DebtCapaSimulatorDTO;